import React from "react";
import { DataAnalyticsLocations, DataAnalyticsTypes, buildAnalytics } from '../basic/analytics';

const OneTrustLink = ({className,label}:{className:string,label: string}) => {
    return (
    <div className={className}>
        <a className="text-white text-base  hover:text-navBlueHover" href="javascript:(OneTrust.ToggleInfoDisplay())" data-analytics-location={`${DataAnalyticsLocations.Page}:${DataAnalyticsLocations.Footer}`} data-analytics-click={label} data-analytics-type={DataAnalyticsTypes.Link}>{label}</a>
    </div>
    )
}
export default OneTrustLink